import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["text", "input"]

    connect() {
        // Prevent datepicker nav button clicks from bubbling to window
        // This fixes the issue where prev/next/today buttons close the calendar
        // Use bubble phase (false) so datepicker handlers run first
        this.boundStopNavPropagation = this.stopNavPropagation.bind(this)
        this.element.addEventListener('click', this.boundStopNavPropagation, false)
    }

    disconnect() {
        this.element.removeEventListener('click', this.boundStopNavPropagation, false)
    }

    stopNavPropagation(event) {
        // Stop clicks inside the calendar from bubbling to window
        // (prevents closeOnOutsideClick from firing)
        if (event.target.closest('.sdp-cal')) {
            event.stopPropagation()
        }
    }

    // Called when datepicker changes the input value
    changed() {
        const value = this.inputTarget.value
        if (value) {
            const date = new Date(value + 'T00:00:00')
            this.textTarget.textContent = this.formatDate(date)
            this.textTarget.classList.remove('hidden')
        } else {
            this.textTarget.textContent = ''
            this.textTarget.classList.add('hidden')
        }
    }

    formatDate(date) {
        const now = new Date()
        const options = { month: 'short', day: 'numeric' }
        if (date.getFullYear() !== now.getFullYear()) {
            options.year = 'numeric'
        }
        return date.toLocaleDateString('en-US', options)
    }
}
